/* eslint-disable no-nested-ternary */
/* eslint-disable jsx-a11y/anchor-is-valid */
/* eslint-disable no-unused-vars */
// import ConnectorActions from './ConnectorActions';
import { localDate } from '../../../utils/dateUtils';
import {
  Button,
  Typography,
  Tabs,
  Badge,
  Row,
  Col,
  Card,
  Divider,
  Table,
  Tooltip,
  Tag,
} from 'antd';
import { get, map } from 'lodash-es';
// import { UpOutlined, DownOutlined } from '@ant-design/icons';

const { Title, Text } = Typography;

export default function Connectors({ connectors, cpid }) {
  const columns = [
    {
      title: 'Id',
      dataIndex: 'CONNECTOR_ID',
      render: (name, connector) => <>{get(connector, 'CONNECTOR_ID')}</>,
      key: 'CONNECTOR_ID',
    },
    {
      title: 'Type',
      dataIndex: 'TYPE',
      render: (name, connector) => <>{get(connector, 'TYPE')}</>,
      key: 'TYPE',
    },
    {
      title: 'Status',
      dataIndex: 'STATUS',
      render: (name, connector) => (
        <Tag
          color={
            get(connector, 'STATUS') === 'Available'
              ? 'blue'
              : get(connector, 'STATUS') === 'Charging'
              ? 'green'
              : get(connector, 'STATUS') === 'Finishing'
              ? 'orange'
              : 'volcano'
          }
        >
          {get(connector, 'STATUS')}
        </Tag>
      ),
      key: 'STATUS',
    },
    {
      title: 'Status updated at',
      dataIndex: 'STATUS_UPDATED_AT',
      render: (name, connector) => (
        <>{localDate(get(connector, 'STATUS_UPDATED_AT'))}</>
      ),
      key: 'STATUS_UPDATED_AT',
    },
  ];

  function makeData(connectorsArray) {
    const formattedConnectors = map(connectorsArray, (conn, c) => ({
      key: c,
      CONNECTOR_ID: get(conn, 'CONNECTOR_ID'),
      STATUS: get(conn, 'STATUS'),
      STATUS_UPDATED_AT: get(conn, 'STATUS_UPDATED_AT'),
      TYPE: get(conn, 'TYPE'),
    }));
    return formattedConnectors;
  }

  const getTitle = () => (
    <div
      style={{
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'center',
      }}
    >
      <Title level={4}>Connectors</Title>
    </div>
  );

  return (
    <>
      <Table
        rowKey="key"
        columns={columns}
        dataSource={makeData(connectors)}
        pagination={false}
        title={() => getTitle()}
        bordered
        // expandable={{
        //   expandedRowRender: (record) => (
        //     <ConnectorActions cpid={cpid} connector={record} />
        //   ),
        //   rowExpandable: (record) => record,
        //   expandRowByClick: true,
        //   expandIcon: ({ expanded, onExpand, record }) =>
        //     expanded ? (
        //       <Text
        //         style={{ color: '#3678b9', cursor: 'pointer' }}
        //         onClick={(e) => onExpand(record, e)}
        //       >
        //         Actions <UpOutlined />
        //       </Text>
        //     ) : (
        //       <Text
        //         style={{ color: '#3678b9', cursor: 'pointer' }}
        //         onClick={(e) => onExpand(record, e)}
        //       >
        //         Actions
        //         <DownOutlined />
        //       </Text>
        //     ),
        //   columnWidth: 100,
        // }}
      />
    </>
  );
}
